import { AutogenModelEdiPartnerCodeDetail, AutogenRowEdiPartnerCodeDetail } from "./autogen/AutogenModelEdiPartnerCodeDetail";

export class ModelEdiPartnerCodeDetail extends AutogenModelEdiPartnerCodeDetail<RowEdiPartnerCodeDetail> {
	constructor() {
		super(RowEdiPartnerCodeDetail);
	}
}

export class RowEdiPartnerCodeDetail extends AutogenRowEdiPartnerCodeDetail {
}